import formatTime from 'mn-utils/formatTime';
const getDateRange = require("../../../../dumb/IntervalFilterCustom/utils/getDateRange");

module.exports = (filter) => {
  const {from, to} = getDateRange(filter);

  return {
    search: filter.search || null,
    from: from ? formatTime.getRFC3339(from) : null,
    to: to ? formatTime.getRFC3339(to) : null,
  };
}